<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="Text-body-standard-indent">We were so lucky to have been hiding out in our hole. The complex had protected us, not just from zombies, but from the intensity of the end of the world. It was a cocoon, wrapping us in its safe walls. How were we going to survive in a world that looked like the zombie wars ended with humanity under the shoes of the dead? </p>
<p class="Text-body-standard-indent1">My eyes fell on one zombie in particular. It was a young woman who had worked in one of the nightclubs. She still wore the uniform of her employer, a pair of short shorts and what had been a white tank top that would have hugged her curves. I could imagine her when she was alive, a young girl with her whole life ahead of her. She had probably been pretty, but the time spent dead had not been kind. Her death had been brutal. Her long blond hair had been a latch-on point for a zombie hand. The grip had torn the scalp from her head on the right side, part of her face had been peeled away and still hung at the jawline, and her right eye was missing. Her bones were exposed in her lower right arm, and her hand was missing. Her skin was shriveled and leathery. Her remaining eye had clouded over but still seemed to scan the environment for food. I wonder if she fought when they came. Did she kick and scream and work to stay alive only to meet this horrible end?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// highway.vue?d7cc7b88